import React from "react"
import { Box, Flex } from "@chakra-ui/react"
import { Step } from "@/types"
import { Text } from "./"

export const StepItem: React.FC<{ step: Step, isLast: boolean, isCurrent: boolean, isCompleted: boolean }> = ({ step, isLast, isCurrent, isCompleted }) => {
  return (
    <Flex align="flex-start" position="relative" w="100%" maxH={60}>
      <Flex
        align="center"
        justify="center"
        w={6}
        h={6}
        borderRadius="full"
        border={isCompleted ? "0px solid" : "1px solid"}
        borderColor={isCompleted || isCurrent ? "brand.300" : "gray.300"}
        bg={isCompleted ? "brand.300" : "white"}
        color={isCompleted ? "white" : "gray.300"}
        flexShrink={0}
        fontSize="sm"
        zIndex={1}
      >
        {<Box w={2} h={2} borderRadius="100%" bg={isCompleted ? "white" : isCurrent ? "brand.300" : "gray.300"} />}
      </Flex>
      {!isLast && (
        <Box
          position="absolute"
          top={6}
          left={2.5}
          w="2.5px"
          h="calc(100% - 0.5rem)"
          bg={isCompleted ? "brand.300" : "gray.300"}
          zIndex={0}
        />
      )}
      <Box ml={4}>
        <Text
          pt={1}
          pb={2}
          fontSize={isCurrent ? "md" : "sm"}
          fontWeight={isCurrent ? "bold" : "normal"}
          color="text.primary"
        >
          {step.title}
        </Text>
        {
          isCurrent && (
            <Text
              fontSize="xs"
              color="text.primary"
              pb={2}
            >
              {step.description}
            </Text>
          )
        }
      </Box>
    </Flex>
  )
}